import { Injectable } from '@angular/core';
import { deps } from '../deps.data';
import { Attendee } from '../models/cart/attendee.model';
import { Service } from '../models/cart/service.model';
import { Real } from '../models/real.model';

@Injectable({
  providedIn: 'root'
})
export class DepsService {

  constructor() {}

  hasDepsPicked( serviceInvestigated, fullfilledByArr, servicesPicked ) {
    
    for( let s of servicesPicked ) {
      
      if ( fullfilledByArr.indexOf( s.id ) !== -1 ) {
        return true;
      }

      if ( fullfilledByArr.indexOf( s.parentId ) !== -1 ) {
        return true;
      }

    }

    return false;

  }

  getFullfilledByText(fullfilledBy, servicesSnapshot) {

    
    let namesArr: string[] = [];
    
     for ( let serviceId of fullfilledBy ) {
       
       if ( !servicesSnapshot[ serviceId.toString() ] ) {
        continue;
       }

       namesArr.push( '"' + servicesSnapshot[serviceId].name + '"');

     }

     return namesArr.join(' ali ');

  }

  getMissingDeps( attendee: Attendee, real: Real, servicesSnapshot: any ) {

    let textArr = [];

    if ( !attendee.services ) {
      return false;
    }

    for( let service of attendee.services ) {


      if ( !service.dependencies || !service.dependencies[ 'fullfilledBy' ] || !service.dependencies[ 'fullfilledBy' ][0] ) {
      
        if ( !service.parentDependencies || !service.parentDependencies[ 'fullfilledBy' ] || !service.parentDependencies[ 'fullfilledBy' ][0] ) {
          continue;
        }

        if ( this.hasDepsPicked( service, service.parentDependencies[ 'fullfilledBy' ], attendee.services ) ) {
          continue;

        } else { //deps missing

          if ( service.parentDependencies[ 'text' ] && service.parentDependencies[ 'text' ].length > 10 ) {
            textArr.push( service.parentDependencies[ 'text' ] );
            continue;
          }

          let text = 'Izbrana storitev "' + service.name + '" zahteva, da izberete še eno od naslednjih storitev:  ';
          text += this.getFullfilledByText( service.parentDependencies[ 'fullfilledBy' ], servicesSnapshot );
          textArr.push( text );
          continue;

        }

      }

      if ( this.hasDepsPicked( service, service.dependencies[ 'fullfilledBy' ], attendee.services ) ) {
        continue;

      } else { //deps missing

        if ( service.dependencies[ 'text' ] && service.dependencies[ 'text' ].length > 10 ) {
          textArr.push( service.dependencies[ 'text' ] );
          continue;
        }

        let text = 'Izbrana storitev "' + service.name + '" zahteva, da izberete še eno od naslednjih storitev:  ';
        text += this.getFullfilledByText( service.dependencies[ 'fullfilledBy' ], servicesSnapshot );
        textArr.push( text );
        continue;
      }


    }

    return textArr;

  }

}